/**
 * The way out of a long list.
 *
 * A button rather than infinite scroll, and that is a deliberate choice for
 * this screen: the home screen has a bottom — "nothing needs you today" — and
 * a list that grows as you scroll never lets you reach it. Someone with forty
 * things in the cupboard should still be able to finish in a minute.
 *
 * It counts what is left rather than saying "more", because the number is the
 * useful part: "and 23 more" tells you whether it is worth the tap.
 */
export function ShowMore({
  label,
  hidden,
  onClick,
  testid,
}: {
  /** Already worded for the number remaining — see data/paging.ts. */
  label: string;
  hidden: number;
  onClick: () => void;
  testid: string;
}) {
  if (hidden === 0) return null;

  return (
    <button type="button" className="more" onClick={onClick} data-testid={testid}>
      <span>{label}</span>
      <span className="more-count">{hidden} hidden</span>
    </button>
  );
}
